exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".activeFilter-2ed46 svg{fill:#1677ff}", ""]);

// Exports
exports.locals = {
	"activeFilter": "activeFilter-2ed46"
};